import {
  CalculatedInfo,
  GeneralInfo,
  OrderBook,
  OrderStatus,
  OrderStrategy,
} from "./orderInterfaces";
import {
  StepOptionOrderType,
  StepOrderSide,
  VolumeCalculationType,
} from "./stepInterfaces";
import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface INLegsSearchParam extends ISearchParameters {
  instrumentId: number;
  sahraUserId: number;
  offsettype?: number;
  optionOrderTypes?: StepOptionOrderType[] | null;
  portfolioGroupId?: number;
}

export interface INLegsTableReport extends ITableReport {
  algorithm_order_id: number;
  condition_id?: number | null;
  instrumentInfo: {
    ratio: number;
    orderSide: StepOrderSide;
    instrumentId: string;
    instrumentName: string;
  }[];
  isActive: boolean;
  orderStatus: OrderStatus;
  maxPairPosition: number;
  sahraName: string;
  sendMode: string;
  sendOrder: string;
}

export enum NLegSendMode {
  Simultaneous = 0,
  Sequential = 1,
}

export interface INLegsTradeTableReport extends ITableReport {
  orderStrategy: OrderStrategy;
  shekarOrderId: number;
  sahraName: string;
  namad: string;
  orderSides: string;
  ratio: string;
  offset: string;
  doneUnit: number;
  totalUnit: number;
  percentage: number;
  totalSize: string;
  volume: string;
  exePrice: string;
  maxPairPosition: number;
  initialMaxPairPosition: number;
  donePercent: number;
  sahraUserId: number;
  sellInstrument: string;
  buyInstrument: string;
  ratios: number[];
  instrumentInfo: {
    ratio: number;
    orderSide: StepOrderSide;
    instrumentId: string;
    instrumentName: string;
  }[];
}

export interface IUNLegsItem {
  instrumentId: string;
  orderSide: StepOrderSide;
  optionOrderType?: StepOptionOrderType;
  // UNLegsItemDTO uses an explicit JSON name in preview responses.
  OptionOrderType?: StepOptionOrderType | null;
  optionOrderTypeEnum?: StepOptionOrderType | null;
  instrumentName?: string | null;
  ratio: number;
  volume: number;
  contractSize: number;
}

export type INLegExcelPreviewItem = IUNLegsItem;

export interface INLegsAddOrderFormValues {
  userIds?: number[];
  userId?: number;
  uNLegsItems: IUNLegsItem[];
  maxPairPosition: number | null;
  blockSizePercent: number | null;
  marginPercent: number | null;
  volumeType?: VolumeCalculationType;
  volumeTypeValue?: number | null;
  sendMode?: NLegSendMode;
  sendPriorities?: number[];
}

export interface INLegOrderbooksBody {
  count: number;
  insIds: {
    insId: string;
    ratio: number;
    side: StepOrderSide;
  }[];
}

export interface IBulkOrderRow extends ITableReport {
  uNLegsItems?: INLegExcelPreviewItem[];
  blockSizePercent: number;

  userId: number;
  userName: string;
  insName1: string;
  instrumentId1: string;
  optionType1: number;
  ratio1: number;
  volume1: number;
  insName2: string;
  instrumentId2: string;
  optionType2: number;
  ratio2: number;
  volume2: number;
  insName3: string;
  instrumentId3: string;
  optionType3: number;
  ratio3: number;
  volume3: number;
  marginPercent: number;
  maxSetPosition: number;
  row: number;
  sheet: string;
}

export interface INLegFileUploadResp {
  sendOrder?: string;
  orderRow: IBulkOrderRow;
  row: number;
  id: number;
  username: string;
  InsName1: string;
  InsName2: string;
  InsName3: string;
  maxSetPosition: number;
  blockSize: number;
  Volume1: number;
  Volume2: number;
  Volume3: number;
  ratio1: string;
  ratio2: string;
  ratio3: string;
  marginInPercent: string;
}

export interface INLegOrderFillSearchParams extends ISearchParameters {
  sahraOrderId?: number;
  nLegId?: number;
}

export interface INLegChanceSearchParams extends ISearchParameters {
  nLegId: number;
}

export interface IEditNLegOrderFormValues {
  nLegOrderId: number;
  maxPairPosition: number;
  applyToSimilar: boolean;
}

export interface INLegOrderbooksResp {
  orderBooks: GetBookOrderResponse[];
  totalPrices: INLegTotalPrice[];
}

export interface INLegTotalPrice {
  price: number;
  ratios: {
    ratio: number;
    orderSide: StepOrderSide;
  }[];
}

export interface GetBookOrderResponse {
  fullOrderBook: OrderBook;
  generalInfo: GeneralInfo;
}
